import { Typography } from "@mui/material";
import { Grid } from "@mui/system";
import React from "react";
import Statcast from "./images/Statcast.png";
import MLB from "./images/MLB.png";
import Fangraphs from "./images/fangraphs.png";

export default function Footer() {
  return (
    <div>
      <Grid
        container
        justifyContent="center"
        spacing={0}
        alignContent="center"
        sx={{
          maxWidth: "100vw",
          width: "100%",
          border: "#293241 solid 1px",
          padding: "10px",
          backgroundColor: "#25364c",
        }}
      >
        <Grid
            container
            justifyContent="center"
            spacing={0}
            width="100%"
            alignContent="center"
          >
        <Typography
          variant="h5"
          style={{ color: "#FFFFFF", marginTop: "10px", textAlign: "center" }}
        >
          Prospect Savant is not affiliated with MLB, nor with any of their digital properties. Email all recommendations, requests, compliments, bugs, and business inquiries to
          duke@prospectsavant.com
        </Typography>
        </Grid>
        <Grid
          container
          justifyContent="center"
          spacing={2}
          maxWidth="100%"
          alignContent="center"
          sx={{
            maxWidth: "100vw",
            width: "100%",
            border: "#293241 solid 1px",
            backgroundColor: "#25364c",
          }}
        >
          <Grid
            container
            justifyContent="center"
            spacing={0}
            maxWidth="80%"
            alignContent="center"
            width="400px"
            height="200px"
          >
            <a href="https://baseballsavant.mlb.com/">
              <img
                src={Statcast}
                height="128px"
                alt=""
                style={{ marginLeft: "10px", marginTop: "10px" }}
              />
            </a>
            <Typography
              style={{ color: "#FFFFFF", textAlign: "center" }}
              variant="body2"
            >
              Pitch-by-pitch and physics data provided by Statcast.
            </Typography>
          </Grid>
          <Grid
            container
            justifyContent="center"
            spacing={0}
            maxWidth="80%"
            alignContent="center"
            width="400px"
            height="200px"
            paddingTop="10px"
          >
            <a href="https://www.mlb.com/">
              <img
                src={MLB}
                height="80px"
                alt=""
                style={{
                  marginLeft: "10px",
                  marginTop: "10px",
                  marginBottom: "20px",
                }}
              />
            </a>

            <Typography
              style={{ color: "#FFFFFF", textAlign: "center" }}
              variant="body2"
            >
              Major League and Minor League Baseball data provided by Major
              League Baseball. Headshots provided by MLB Photos. Prospect Savant is unaffiliated with MLB.
            </Typography>
          </Grid>
          <Grid
             container
             justifyContent="center"
             spacing={0}
             maxWidth="80%"
             alignContent="center"
             width="400px"
             height="200px"
             paddingTop="10px"
           >
             <a href="https://www.fangraphs.com/">
               <img
                 src={Fangraphs}
                 height="80px"
                 alt=""
                 style={{
                   marginLeft: "10px",
                   marginTop: "10px",
                   marginBottom: "20px",
                   boxShadow: "1px 1px 1px white",
                   border: "5px solid white"
                 }}
               />
             </a>
 
             <Typography
               style={{ color: "#FFFFFF", textAlign: "center" }}
               variant="body2"
             >
               Prospect ranks and draft info provided by
               FanGraphs. For full AAA wRC+ rankings, visit FanGraphs! Prospect Savant gladly provides it's EV90 data to the OOPSY Projection system.
             </Typography>
           </Grid>
        </Grid>
        <Grid
            container
            justifyContent="center"
            spacing={0}
            width="100%"
            alignContent="center"
            height="100px"
          >
        <Typography
          variant="h5"
          style={{ color: "#FFFFFF", marginTop: "10px", fontSize: "8px", textAlign: "center"}}
        >
          Created, developed, maintained, and funded by Ethan "Duke" Hill. No purchase necessary. Prospect Savant is not responsible for any limbs lost while browsing website.
        </Typography>
        </Grid>
      </Grid>
    </div>
  );
}
